import React from 'react';
import { Bar } from './styled';

function ColoredBar(): JSX.Element {
  return (
    <Bar>
      <div> </div>
      <div> </div>
      <div> </div>
      <div> </div>
      <div> </div>
    </Bar>
  );
}

export default ColoredBar;
